import * as css from './style.css';
import {STATIC_IMAGE} from '../../../config/config';

interface EventHeaderProps {
    nameFirst: string;
    nameLast: string;
}

function EventHeader({nameFirst, nameLast}: EventHeaderProps) {
    return (
        <css.blueHeader>
            <img
                src={`${STATIC_IMAGE}/tickchakLogo.png`}
                alt=""
            />
        </css.blueHeader>
    );
}

export default EventHeader; 